import LubricantService from "./LubricantService";

export default LubricantService;
